module.exports = __webpack_public_path__ + "static/media/news0.acbe666c.png";